export default __webpack_public_path__ + "89a0a1db14d7cee416182d14bc0a7cfd.jpg";